import { setSession, UserData_model } from '@shared/library';
import axios from 'axios';
import React from 'react';
import { decodeToken } from 'react-jwt';
import { useLocation } from 'react-router-dom';
import loadingGif from '../../../assets/images/loading.gif';
import { config } from '../../../static/config';
import './SplashScreen.scss';
//CONTEXTS
import { CntxConfig } from '../../Optisewer';


const SplashScreen = () => {
    //CONTEXTS USE
    const cntxConfig = React.useContext(CntxConfig)!;

    //STATIC DATA
    const location = useLocation();

    //METHODS
    const isLoggedInAPI = () => {
        axios.get<{ token: string; }>(`${config.api.internal}/Auth/SessionValid`, { withCredentials: true })
            .then(res => {
                const token = res.data.token;
                const userData = decodeToken<UserData_model>(token);

                if (userData) {
                    setSession(cntxConfig, { userData, support: localStorage.getItem('support') === '1' });
                }
                else {
                    setTimeout(isLoggedInAPI, 1000);
                }
            })
            .catch(error => {
                if (error?.code === 'ERR_NETWORK') {
                    setTimeout(isLoggedInAPI, 1000);
                }
                else {
                    cntxConfig?.set?.(undefined);
                }
            });
    };

    //STATES CHANGE
    React.useEffect(isLoggedInAPI, [cntxConfig, location]);

    return <img src={loadingGif} alt="loading" loading='lazy' id="SplashScreen" />;
};
export default React.memo(SplashScreen);